import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    path: '/biblioteca/bibrelatorioemprestimo/0',
    name: 'bibrelatorioemprestimocentral',
    description: 'Controle Empréstimo Biblioteca Central',
    component: () => import('@/views/biblioteca/bibrelatorioemprestimo/Index.vue'),
    props: { bibliotecaEscola: false },
    meta: { permissions: [eTipoPermissao.BIB_CONTROLEEMPRESTIMORESERVACENTRALNOVO_MENU_1300400699] },
    goesToMenu: true,
  },
  {
    path: '/biblioteca/bibrelatorioemprestimo/1',
    name: 'bibrelatorioemprestimoescola',
    description: 'Controle Empréstimo Biblioteca Escola',
    component: () => import('@/views/biblioteca/bibrelatorioemprestimo/Index.vue'),
    props: { bibliotecaEscola: true },
    meta: { permissions: [eTipoPermissao.BIB_CONTROLEEMPRESTIMORESERVAESCOLANOVO_MENU_1300400599] },
    goesToMenu: true,
  },
];
